module.exports = __webpack_public_path__ + "img/编组 12备份 4@2x.b901637f.png";